import { render, staticRenderFns } from "./CustomerPrepaymentAccountList.vue?vue&type=template&id=30daefae&lang=pug&"
import script from "./CustomerPrepaymentAccountList.vue?vue&type=script&lang=js&"
export * from "./CustomerPrepaymentAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CustomerPrepaymentAccountList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports